import React from 'react';
import {useSelector} from "react-redux";
import {
    bbDangerousStringToDate,
    BBDisableChildren, bbFindEntityWithinPortfolioOrSelf,
    bbFormattedDateString,
    bbIsUserManagerOfEntity,
    filterObject,
    isCurrentUserMemberOf,
    mapObject
} from "../../../util/bbHelpers";
import PropTypes from "prop-types";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import BBDataTable from "../tables/BBDataTable";
import {renderCellExpand} from "../tables/DataGridRenderCellExpand";
import {Chip, Typography} from "@material-ui/core";
import RequestBRBusinessShareDialog from "./RequestBRBusinessShareDialog";
import BRBusinessShareToggleSwitch from "./BRBusinessShareToggleSwitch";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {HashLink as Link} from "react-router-hash-link";
import {Badge} from "reactstrap";
import UpdateApprovedShareAccessLevelDialog from "./UpdateApprovedShareAccessLevelDialog";

const TableContainer = ({
    removePendingInactiveShares = false,
    removeApprovedActiveShares = false,
    removeSharesNotRequested = false,
    removeSharesNotActive = false,
    verbose = false,
    archivedOnly = false,
    constTitleOverrideText = null,
    showBRPView = false,
    tableTipText= null,
    disableColumnSelector,
    disableDensitySelector,
    disableColumnMenu,
    disableColumnFilter,
                            showAddButton = false,
                        }) => {

    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {portfolios, loadingPortfolios, loadingPortfoliosError, entityInView} = useSelector(({breachrisk}) => breachrisk);
    const {authUser} = useSelector(({auth}) => auth);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const customer = customers ? customers[customerIdToUse] : null;
    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);

    const currentShares =
        portfolios
        && customerIdToUse
        && authUser
        && portfolios[customerIdToUse]
        ? portfolios[customerIdToUse].shares
            : null;

    console.group("BRBusinessSharingTable Preparing to filter the sharing table", "currentShares", currentShares, "customerIdToUse", customerIdToUse, "authUser", authUser);

    // console.log("SHARES this is myEntity" , myEntity,"and current shares inside of the data sharing page", portfolios && portfolios[customerIdToUse], currentShares);

    //TODO: should shares inside of business only be displayed if the entity (ie, the one sharing) is equal to the entity in view?

    console.log("Preparing to filter out shares",
        "removeApprovedActiveShares", removeApprovedActiveShares,
        "removePendingInactiveShares", removePendingInactiveShares,
        "archivedOnly", archivedOnly,
        "showBRPView", showBRPView,
        "myEntity", myEntity
    );

    let sharesToShow = currentShares
        ? removeApprovedActiveShares
            ? filterObject(currentShares, (_, share) => (!(share.approved && share.is_active)))
            : removePendingInactiveShares
                ? filterObject(currentShares, (_, share) => !(!share.approved || !share.is_active))
                : archivedOnly
                    ? filterObject(currentShares, (_, share) => (!share.is_active && !share.approved) || !share.is_active)
                    : currentShares
                    // : showBRPView
                    //     ? filterObject(currentShares, (_, share) => (share.is_active))
                    //     : currentShares
        : null;

    console.log("Preparing to filter out inbound shares removeSharesNotRequested", removeSharesNotRequested);
    if (removeSharesNotRequested) {
        sharesToShow = filterObject(sharesToShow, (_, share) => share.requested)
    }
    console.log("Shares to show is now", "sharesToShow", sharesToShow);

    console.log("Preparing to filter out inbound shares removeSharesNotActive", removeSharesNotActive);
    if (removeSharesNotActive) {
        sharesToShow = filterObject(sharesToShow, (_, share) => share.is_active)
    }
    console.log("Shares to show is now", "sharesToShow", sharesToShow);

    //if this is not the portfolio view, the only shares that should be shown
    console.log("Preparing to filter out inbound shares from the non BRP View. showBRPView", showBRPView, "myEntity.id", myEntity && myEntity.id);
    if (!showBRPView && myEntity) {
        sharesToShow = filterObject(sharesToShow, (_, share) => share.entity && share.entity.id === myEntity.id )
    }
    console.log("Shares to show is now", "sharesToShow", sharesToShow);

    //if this is not the portfolio view, the only shares that should be shown
    console.log("Preparing to filter out inbound shares from the BRPView. showBRPView", showBRPView, "customerInView", customerInView);
    if (showBRPView && customerInView) {
        sharesToShow = filterObject(sharesToShow, (_, share) => share.customer && share.customer.id === customerInView )
    }
    console.groupEnd();

    const totalNumShares = sharesToShow ? Object.keys(sharesToShow).length : 0;


  /**************************/
  /*End Setup State and Dispatch*/
  /**************************/

    const title = !archivedOnly
                    // && !showBRPView
        ? <div className={"tourStepBRPortfolioManageShares"} id={"tourSharingTableTitle"}>
        {removePendingInactiveShares
            ? "Active BreachRisk™ Share Requests"
            : removeApprovedActiveShares
                ? "Inbound Requests for your BreachRisk™ Details"
                : constTitleOverrideText
                    ? constTitleOverrideText
                    : null
        }{tableTipText && <Tooltip title={tableTipText}>
        <InfoSharpIcon style={{fontSize: "smaller"}} className={``}/>
    </Tooltip>}
    </div>
    : null;



  const userTableHeadings = [
      // { field: 'id', headerName: 'ID (full)', hide: false, flex : 2, sortable: true, type: 'string', renderCell: (params) => {
      //
      //                 return params.value.slice(0,6)}},
      { field: 'entityName', headerName: 'Company Name ', hide: !(!verbose && !removePendingInactiveShares) || !showBRPView, sortable: true, type: 'string',  flex:.5 , renderCell: (params) =>
              renderCellExpand(params,
                  // showBRPView ? (<Link smooth to={`Details/Scores?entityID=${params.row.id}`} style={{ textDecoration: "none", color: "black" }}>
                  //     {params.value}
                  // </Link>) :
                  (<Tooltip title={``}>
                          <span>
                              {params.value}
                          </span>
                  </Tooltip>

              ))},
      { field: 'companyName', headerName: !verbose && !removePendingInactiveShares ? 'Making Request' : 'Shared With', hide: showBRPView, sortable: true, type: 'string',  width: 200, renderCell: (params) =>
              renderCellExpand(params, (<Tooltip title={``}>
                          <span>
                              {params.value}
                          </span>
                  </Tooltip>

              ))},

      { field: 'createdDatetime', headerName: 'Created', hide: false, sortable: true, type: 'string',  width:150, renderCell: (params) =>
              renderCellExpand(params, (<Tooltip title={``}>
                          <span>
                              {bbFormattedDateString(params.value, "short")}
                              {/*{showBRPView && !params.row.isApproved ? `${params.row.contact}` : null}*/}
                          </span>
                  </Tooltip>

              ))},
      { field: 'comments', headerName: 'Comments', hide: verbose, sortable: true, type: 'string', flex: 1.5, renderCell: (params) =>
              renderCellExpand(params, (<Tooltip title={``}>
                          <Typography style={{fontFamily: "monospace"}}>
                             {params.value}
                          </Typography>
                  </Tooltip>

              ))},
      { field: 'isRequested', headerName: 'Requested', hide: !verbose, sortable: true, type: 'string',  width: 140, renderCell: (params) =>
              renderCellExpand(params, (
                  <Tooltip title={``}>
                          <span>
                             <Chip

                                 label={params.value ? "Requested" : "Not Requested"}
                                 // avatar={names.avatar}
                                 color={params.value ? "primary" : "default"}
                             />
                          </span>
                  </Tooltip>

              ))},
      { field: 'requestedByName', headerName: 'Requested By', hide: !removeApprovedActiveShares && !verbose, sortable: true, type: 'string', flex: 0.7, renderCell: (params) =>
              renderCellExpand(params, (<Tooltip title={``}>
                          <span>
                             {params.value}
                          </span>
                  </Tooltip>

              ))},
      { field: 'requestedByEmail', headerName: 'Requester Email', hide: !removeApprovedActiveShares && !verbose, sortable: true, type: 'string', flex: 1, renderCell: (params) =>
              renderCellExpand(params, (<Tooltip title={``}>
                          <span>
                             {params.value}
                          </span>
                  </Tooltip>

              ))},
      { field: 'deactivatedDatetime', headerName: 'Last Status Change', hide: !verbose, sortable: true, type: 'string',  flex: 1, renderCell: (params) =>
              renderCellExpand(params, (<Tooltip title={``}>
                          <span>
                              {bbFormattedDateString(params.value, "long")}
                          </span>
                  </Tooltip>

              ))},
      { field: 'dataLevelName', headerName: 'Data Level', hide: false, sortable: true, type: 'string',  flex: 1,
          renderHeader: (params)=> (<Tooltip heading={"Access Level"}
                                             title={"Different sharing relationships allow you to determine what another company knows about your risk, security, and infrastructure."}
                                             link={"https://support.breachbits.com/knowledge/requesting-access"}>
              <span id={"tourDataLevelHeader"} className={"tourDataLevelHeader"}>
                  Access Level
              </span>
       </Tooltip>
), cellClassName: "tourDataLevelCol",
          renderCell: (params) => renderCellExpand(params, (removePendingInactiveShares ?
                      <UpdateApprovedShareAccessLevelDialog share={params.row}/>
                      : <Tooltip title={params.row.dataLevelDescription}>
                          <span>
                              {params.value}
                          </span>
                      </Tooltip>
              ))},
      { field: 'isApproved', headerName: 'Approval', hide: archivedOnly || showBRPView, sortable: true, type: 'string',  width: 120,
          renderHeader: (params)=> <span id={"tourApprovalHeader"} className={"tourApprovalCol"}>Approval</span>, cellClassName: "tourApprovalCol",
          renderCell: (params) =>
              renderCellExpand(params, (
                  <BRBusinessShareToggleSwitch
                      customerId={params.row.customerId}
                      shareId={params.row.id}
                      shareProperty={"approved"}
                      title ={params.value ? "Approved: Disable this switch to remove approval for this share to stop sharing." : "Pending Approval: Enable this switch to approve this request and share your score" }
                      label={params.value ? "Approved" : "Not Approved"}
                      className={"text-center"}
                      />

              ))},

      // { field: 'isActive', headerName: 'Activation', hide: showBRPView, sortable: true, type: 'string',  width: 120,
      //     renderHeader: (params)=> <span id={"tourActiveHeader"} className={"tourActiveCol"}>Activation</span>, cellClassName: "tourActiveCol",
      //     renderCell: (params) =>
      //         renderCellExpand(params, (
      //             <BRBusinessShareToggleSwitch
      //                 customerId={params.row.customerId}
      //                 shareId={params.row.id}
      //                 title ={ params.value ? "Active: Disable this switch to ignore this request or to disable sharing and move it to the Archive." : "Inactive: Enable this switch to remove from the Archive and enable the sharing option."}
      //                 shareProperty={"is_active"}
      //                 label={params.value ? "Active" : "Inactive"}
      //                 className={"text-center"}
      //             />
      //
      //         ))},
      { field: 'isApprovedBRPView', headerName: 'Approval', hide: !showBRPView, sortable: true, type: 'string',  width: 150, renderCell: (params) =>
              renderCellExpand(params, (
                  <Badge
                      color={!params.row.isActive ? "brThemeColorRed1" : params.value ? "primary" : "lighter-gray"}
                  >
                      {!params.row.isActive ? "Disapproved" : params.value ? "Approved" : "Pending..." }
                  </Badge>

              ))},

  ];

    //peel the state data into a form the dataTable can read
  const tableData = sharesToShow ? mapObject(sharesToShow, (key, share) => {

      return (
        {
            customerId: customer.CustomerId,
            id: key,
            idShort: key.slice(0, 6),
            companyName: share.customer.name,
            entityName: share.entity.name,
            entityId: share.entity.id,
            comments: share.comments,
            requestedByName: share.requested_by ? share.requested_by.name : "N/A",
            requestedByEmail: share.requested_by ? share.requested_by.email : "N/A",
            createdDatetime: bbDangerousStringToDate(share.created_datetime),
            // relatedMapping: share.related_mapping,
            isApproved: share.approved,
            isApprovedBRPView: share.approved,
            isActive: share.is_active,
            isRequested: share.requested,
            dataLevelName: share.data_level && share.data_level.name ? share.data_level.name : "N/A",
            dataLevelId: share.data_level && share.data_level.id ? share.data_level.id : null,
            dataLevelDescription: share.data_level && share.data_level.description ? share.data_level.description : "--",
            // deactivatedDatetime: bbDangerousStringToDate(share.deactivated_datetime),

        }
    )
  }) : null;

    const tableDataAsArray = () => {
        // console.log("Creating humansTableData as array from humanTableData ", tableData);
        let arr=[];
        for (let ob in tableData) {
            // console.log("ob is ", tableData[ob])
            arr.push(tableData[ob]);
        }
        // console.log("resulting array ", arr);
        return arr;
    }


    return (
        <div >
            {((sharesToShow || totalNumShares === 0)
                // && myEntity
                // && myEntity.settings
                && customerIdToUse
                && !loadingPortfoliosError[customerIdToUse]
                && !loadingPortfolios[customerIdToUse]
                // && !loadingCycles[myEntity.settings.last_cycle_id]
                // && !loadingCyclesError[myEntity.settings.last_cycle_id]
            ) ?
            <BBDataTable
                portfolioTrial
                subscriptionNameOrId={showBRPView ? "BRP" : "BRfB"}
                elementDisplayNameForConsoleLogs={`BRBusinessSharingTable ${showBRPView ? "(BRP View)" : "(BRfB View)"}`}
                columns={userTableHeadings}
                rows={tableDataAsArray()}
                totalRows={totalNumShares}
                progressValue={sharesToShow && totalNumShares > 0
                    ? Object.keys(sharesToShow).length / totalNumShares * 100
                    : totalNumShares === 0
                        ? 100
                        : 0}
                // bufferValue={willBeDoneLocalPagewiseLoadingWhenTargetsIs ? willBeDoneLocalPagewiseLoadingWhenTargetsIs / totalNumTargets * 100 : 0}
                title={title}
                enableExport
                loading={false}
                // requiresModule={"monitor"}
                customer={customer}
                // topRightElement={<BBModuleIcon includeTooltip module={bbGetModulePropertyFromIdOrName("monitor", "id")} isActive={bbDoesCustomerHaveAccessToModule(customer, "monitor")} iconSize={"40px"}/>}
                //TODO: make this only visible for admin, staff, and managers
                topRightElement= {showAddButton ?
                    <div className={"row "}>
                        <BBDisableChildren
                            isDisabled={bbIsUserManagerOfEntity(authUser, entityInView) || (isCurrentUserMemberOf(authUser, "admin") || isCurrentUserMemberOf(authUser, "staff"))}
                            // moduleRequired = {"insider"}
                            isCompact
                            isButtonSized
                            blurLevel={2}
                        >
                            <div className={"col-12 align-self-center"}>
                                <RequestBRBusinessShareDialog targetEntityId={entityInView}/>
                            </div>
                        </BBDisableChildren>
                        {/*<div className={"col-2 align-self-center"}>*/}
                        {/*    <BBModuleIcon includeTooltip module={bbGetModulePropertyFromIdOrName("insider", "id")} isActive={bbDoesCustomerHaveAccessToModule(customer, "insider")} iconSize={"40px"}/>*/}
                        {/*</div>*/}
                    </div> : null
                }
                defaultSortModel = {[
                    {
                        field: 'createdDatetime',
                        sort: 'desc',
                    },

                ]}
                rowsPerPageOptions = {[10, 25, 50, 100]}
                defaultPageSize = {10}
                disableColumnSelector={disableColumnSelector}
                disableColumnMenu={disableColumnMenu}
                disableDensitySelector={disableDensitySelector}
                disableColumnFilter={disableColumnFilter}
            />
            :
            <BBDataTable
                columns={userTableHeadings}
                rows={[]}
                title={title}
                loading = {true}
                progressValue={0}
                bufferValue={0}
                rowsPerPageOptions = {[10, 25, 50, 100]}
                defaultPageSize = {10}
                portfolioTrial
                subscriptionNameOrId={showBRPView ? "BRP" : "BRfB"}
            />
            }
        </div>
    );



}
TableContainer.propTypes = {
    customerId: PropTypes.string,
};

export default TableContainer